import {
  Accordion,
  AccordionSummary,
  Avatar,
  Badge,
  Box,
  Divider,
  // IconButton,
  // Menu,
  // MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Wrapper } from "./style";
import { CHATSOCKETURL } from "../../config";
import { useDispatch, useSelector } from "react-redux";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  useFirstName,
  useInvoffUserid,
  useLastName,
} from "../../hooks/useLocalStorage";
import { getColorProfile } from "../../utils/getColorProfile";
import { showSuccessMessage } from "../../components/presentation/common/snackbar";
import ChatWindowContent from "./chatWindowContent";
import notificationAudio from "../../audio/notification.mp3";

const ChatPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const themebody = theme?.palette?.primary;
  const token = sessionStorage.getItem("token");
  const profile_pic = sessionStorage.getItem("profile_pic");

  const firstName = useFirstName();
  const lastName = useLastName();
  const currentUser = useInvoffUserid();
  const randomProfileBg = getColorProfile({ firstName, lastName });

  const { chatConversation } = useSelector((state) => state.chat);

  const [openMessageRequest, setOpenMessageRequest] = useState(false);
  const [socketConnect, setSocketConnect] = useState();
  const [notificationMessage, setNotificationMessage] = useState();
  const [chatRequestData, setChatRequestData] = useState([]);
  const [notificationcount, setNotificationcount] = useState(null);
  const [chatRequestedAlert, setChatRequestedAlert] = useState({});

  const [userOnlineStatusData, setUserOnlineStatusData] = useState([]);

  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);

  const playNotificationSound = () => {
    const audio = new Audio(notificationAudio);
    audio.muted = true;
    audio.play();
    audio.muted = false;
  };

  //notification socket connect
  useEffect(() => {
    if (!CHATSOCKETURL || !token) return;

    let socket;
    let reconnectTimer;
    let attempt = 0;
    let isManuallyClosed = false;

    let heartbeatInterval;
    let heartbeatTimeout;

    const getReconnectDelay = (attempt) => {
      const base = Math.min(1000 * 2 ** attempt, 60000);
      const jitter = Math.random() * 1000;
      return base + jitter;
    };

    const sendHeartbeat = () => {
      if (socket?.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: "ping" }));
        heartbeatTimeout = setTimeout(() => {
          socket.close();
        }, 5000);
      }
    };
    const connect = () => {
      socket = new WebSocket(
        `${CHATSOCKETURL}/ws/chat/notification/?token=${token}`
      );
      setSocketConnect(socket);
      socket.onopen = () => {
        attempt = 0;
        clearInterval(heartbeatInterval);
        heartbeatInterval = setInterval(sendHeartbeat, 25000);
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === "pong") {
            clearTimeout(heartbeatTimeout);
          } else {
            //
          }
        } catch (err) {
          console.error("Invalid WS message", err);
        }
      };

      socket.onclose = () => {
        clearInterval(heartbeatInterval);
        clearTimeout(heartbeatTimeout);

        if (!isManuallyClosed) {
          attempt++;
          const delay = getReconnectDelay(attempt);
          reconnectTimer = setTimeout(connect, delay);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
        socket.close();
      };
    };
    connect();
    return () => {
      isManuallyClosed = true;
      clearTimeout(reconnectTimer);
      clearInterval(heartbeatInterval);
      clearTimeout(heartbeatTimeout);
      if (socket) socket.close();
    };
  }, [token, CHATSOCKETURL]);

  if (socketConnect) {
    socketConnect.onmessage = (event) => {
      const message = JSON.parse(event.data);
      if (message?.notification_type === "chat_request") {
        playNotificationSound();
        setChatRequestData((prev) => {
          if (Array.isArray(prev)) {
            return [message, ...prev];
          } else {
            return [message];
          }
        });
        showSuccessMessage(
          `Chat Requested from ${message?.sender?.first_name} ${" "} ${
            message?.sender?.last_name
          }`
        );
      } else if (message?.notification_type === "message") {
        if (message?.action !== "seen") {
          playNotificationSound();
        }
        setNotificationMessage(message);
      } else if (message?.notification_type === "user_status") {
        setNotificationcount(message?.unseen_message_count);
        setUserOnlineStatusData((prev) => {
          const updatedStatuses = prev?.filter(
            (item) => item?.user !== message?.user
          );
          updatedStatuses.push(message);
          return updatedStatuses;
        });
      } else if (message?.notification_type === "chat_request_alert") {
        setChatRequestedAlert(message);
      }
    };
  }

  useEffect(() => {
    if (notificationMessage) {
      const index = chatConversation?.findIndex(
        (conversation) =>
          conversation?.id === notificationMessage?.conversation_detail?.id
      );
      let updatedConversations = [...chatConversation];
      if (index !== -1) {
        updatedConversations.splice(index, 1);
        updatedConversations.unshift({
          ...chatConversation[index],
          last_message: notificationMessage?.conversation_detail?.last_message,
        });
      } else {
        updatedConversations.unshift({
          ...notificationMessage?.conversation_detail,
          sender:
            notificationMessage?.conversation_detail?.last_message
              ?.sender_detail,
          last_message: notificationMessage?.conversation_detail?.last_message,
        });
      }
      dispatch({
        type: "GET_CHAT_CONVERSATION_SUC",
        payload: updatedConversations,
      });
    }
  }, [notificationMessage, dispatch]);

  const pendingChatReceiveRequest = chatRequestData?.filter(
    (item) => item.status === "PENDING" && item?.receiver === currentUser
  );

  const online_users = useMemo(() => {
    if (userOnlineStatusData?.length) {
      const user_status = userOnlineStatusData?.map((item) => {
        return {
          user: item?.user,
          status: item?.status,
        };
      });
      return user_status;
    }
  }, [userOnlineStatusData]);

  return (
    <Wrapper>
      <Accordion
        expanded={isAccordionExpanded}
        onChange={(e, expanded) => {
          setIsAccordionExpanded(expanded);
          // if (!anchorEl) {
          // }
        }}
        className="fixedButton"
        sx={{
          width: "310px",
          padding: "0px !important",
          // margin: "0px !important",
          // border: `1px solid ${themebody?.grey}`,
          right: {
            xs: "16px",
            xl: "max(16px, calc((100vw - 2000px) / 2 + 16px))",
          },
          borderTopRightRadius: "10px !important",
          borderTopLeftRadius: "10px !important",

          boxShadow: themebody?.boxShadow,
        }}
      >
        <AccordionSummary
          sx={{
            paddingX: "6px !important",
            paddingY: "0px",
            ".MuiAccordionSummary-content": {
              margin: "0px !important",
            },
          }}
          expandIcon={<ExpandLessIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Avatar
                variant="contained"
                alt={firstName}
                src={profile_pic !== "undefined" && `${profile_pic}`}
                sx={{
                  fontSize: "16px",
                  width: "30px",
                  height: "30px",
                  background: randomProfileBg,
                }}
              >
                {firstName?.[0]?.toUpperCase() + lastName?.[0]?.toUpperCase()}
              </Avatar>
              {/* <RenderProfileImage
                fontsize=""
                imageUrl={currentUserProfileImage}
                firstCharacter={firstName?.[0] + lastName?.[0]}
                size="32px"
              /> */}
              <Badge
                color="error"
                variant="dot"
                badgeContent={
                  pendingChatReceiveRequest?.length ||
                  (notificationMessage?.unseen_message_count
                    ? notificationMessage?.unseen_message_count
                    : notificationcount) ||
                  0
                }
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    color: themebody?.textColor,
                    fontWeight: "bold",
                  }}
                >
                  Messaging
                </Typography>
              </Badge>
            </Box>
            {/* <Box
              sx={{
                marginRight: "10px",
              }}
            >
              <IconButton
                sx={{ padding: "2px" }}
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(e) => {
                  e.stopPropagation();
                  setAnchorEl(e.currentTarget);
                  // setOpenMessageRequest(true);
                }}
              >
                <MoreHorizIcon />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsAccordionExpanded(true);
                    setOpenMessageRequest(false);
                    setAnchorEl(null);
                  }}
                >
                  <Badge
                    color="error"
                    badgeContent={
                      notificationMessage?.unseen_message_count
                        ? notificationMessage?.unseen_message_count
                        : notificationcount
                    }
                  >
                    <Typography
                      sx={{
                        paddingTop: "8px",
                        paddingRight: "3px",
                        color: themebody?.textcolor,
                        fontSize: "13px",
                      }}
                    >
                      {t("manage_conversation")}
                    </Typography>
                  </Badge>
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsAccordionExpanded(true);
                    setOpenMessageRequest(true);
                    setAnchorEl(null);
                  }}
                >
                  <Badge
                    color="error"
                    badgeContent={pendingChatReceiveRequest?.length ?? null}
                  >
                    <Typography
                      sx={{
                        paddingTop: "8px",
                        paddingRight: "3px",
                        color: themebody?.textcolor,
                        fontSize: "13px",
                      }}
                    >
                      {t("manage_request")}
                    </Typography>
                  </Badge>
                </MenuItem>
              </Menu>
            </Box> */}
          </Box>
        </AccordionSummary>
        <Divider />
        <AccordionDetails sx={{ padding: "0px !important" }}>
          <ChatWindowContent
            chatRequestedAlert={chatRequestedAlert}
            online_users={online_users ?? []}
            isAccordionExpanded={isAccordionExpanded}
            openMessageRequest={openMessageRequest}
            setChatRequestData={setChatRequestData}
            chatRequestData={chatRequestData}
          />
        </AccordionDetails>
      </Accordion>
    </Wrapper>
  );
};

export default ChatPage;
